import type {
  MobilePlanOffer,
  PriceOption,
} from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'

export function getMobilePlanPriceOption(
  offer: MobilePlanOffer | null | undefined,
  option: PriceOption['option'],
) {
  return offer?.priceOptions.find(
    (priceOption) => priceOption.option === option,
  )
}
